import React from 'react';
import styled from 'styled-components';

const EmptyViewWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
`;

const EmptyListView = () => {
    return (
        <EmptyViewWrapper>
            <div style={{ padding: '25px 0', textAlign: 'center' }}>
                <h3>There are no components or labels in your project yet.</h3>
                <p>
                    Components are subsections of a project. Use them to group issues within a project into smaller
                    parts.
                </p>
            </div>
        </EmptyViewWrapper>
    );
};

export default EmptyListView;
